module.exports = __webpack_public_path__ + "img/ic_head_hight_11.a07e6e1a.png";